import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines, faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { useNavigate } from 'react-router-dom';
import useURLParams from '../hooks/useURLParams';
interface AddModalProps {
    closeModal: () => void;
    modalButtonRef: React.RefObject<HTMLButtonElement>;
}

const AddModal: React.FC<AddModalProps> = ({ closeModal, modalButtonRef }) => {
    const modalRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();
    const { setParam } = useURLParams();

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                modalRef.current &&
                modalButtonRef.current &&
                !modalRef.current.contains(event.target as Node) &&
                !modalButtonRef.current.contains(event.target as Node)
            ) {
                closeModal();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [closeModal]);

    return (
        <div className="add-modal" ref={modalRef}>
            <button
                onClick={() => {
                    closeModal();
                    setParam('modal', 'new-label');
                }}
            >
                <div className="icon-container">
                    <FontAwesomeIcon icon={faFilePdf} />
                </div>
                <p>Check new label</p>
            </button>
            <button
                onClick={() => {
                    closeModal();
                    setParam('modal', 'new-pack-copy');
                }}
            >
                <div className="icon-container">
                    <FontAwesomeIcon icon={faFileLines} />
                </div>
                <p>Add new pack copy</p>
            </button>
        </div>
    );
};

export default AddModal;
